module.exports = __webpack_public_path__ + "img/food-12.7181753b.jpg";